export const getChargePolicy = (type, max) => {
    return { shipping: type === 'MAX_CREATOR' ? { type, max: Number(max) } : { type } };
};
